import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

type QuestionResultRemarkPayload = {
  question_result_id: number;
  remark: string;
};

export const useQuestionResultRemarkMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: QuestionResultRemarkPayload) => {
      await ApiInstance.post("/checks/remark/update", payload);
    },
    onSuccess: ({ question_result_id, remark }) => {
      const checks = typedQueryClient.getQueryData(AppointmentDetailsKeys.checks);
      if (!checks?.length) return;

      const checkIdx = checks.findIndex(check => check.question_items?.some(qr => qr.id === question_result_id));
      if (checkIdx < 0 || !checks[checkIdx].question_items?.length) return;

      const questionResults = checks[checkIdx].question_items;
      const questionResultIdx = questionResults.findIndex(qr => qr.id === question_result_id);
      if (questionResultIdx < 0) return;

      typedQueryClient.setQueryData(
        AppointmentDetailsKeys.checks,
        checks.with(checkIdx, {
          ...checks[checkIdx],
          question_items: questionResults.with(questionResultIdx, { ...questionResults[questionResultIdx], raw: remark })
        })
      );
    }
  });
